import React, { useEffect, useState } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { NotificationBar } from '../components/NotificationBar';
import { HeroSection } from '../components/HeroSection';
import { FearNarrative } from '../components/FearNarrative';
import { SystemSection } from '../components/SystemSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { TrustSection } from '../components/TrustSection';
import { PolicyModal } from '../components/PolicyModal';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  const [modalState, setModalState] = useState<{
    open: boolean;
    tab: 'privacy' | 'terms';
  }>({
    open: false,
    tab: 'privacy'
  });
  return <div className="min-h-screen bg-white font-opensans selection:bg-brand-orange selection:text-white relative" data-id="element-231">
      <NotificationBar data-id="element-232" />
      <main data-id="element-233">
        <HeroSection data-id="element-234" />
        <FearNarrative data-id="element-235" />
        <SystemSection data-id="element-236" />
        <BonusSection data-id="element-237" />
        <ValueStack data-id="element-238" />
        <TrustSection onOpenPrivacy={() => setModalState({
        open: true,
        tab: 'privacy'
      })} onOpenTerms={() => setModalState({
        open: true,
        tab: 'terms'
      })} data-id="element-239" />
      </main>

      <PolicyModal isOpen={modalState.open} activeTab={modalState.tab} onClose={() => setModalState(prev => ({
      ...prev,
      open: false
    }))} onTabChange={tab => setModalState(prev => ({
      ...prev,
      tab
    }))} data-id="element-240" />
    </div>;
}